import { Component, h, Element, Listen, State } from "@stencil/core"
import {
  dialogReducer,
  getInitialState,
  DialogActions,
  DialogState,
} from "../dialog-store"
import {
  StoreConnection,
  StateHandle,
} from "../../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-dialog-toggle",
  styleUrl: "dialog-toggle.scss",
  shadow: true,
})
export class DialogToggle {
  private store: StoreConnection<this, DialogState, DialogActions>

  @Element() public el!: HTMLSdxDialogToggleElement

  @State() public state!: StateHandle<DialogState>

  @Listen("click")
  public onClick() {
    this.store.set("isUserInteractionInProgress", true)
    this.state.get().toggle()
    this.store.set("isUserInteractionInProgress", false)
  }

  constructor() {
    this.store = new StoreConnection(this, dialogReducer, getInitialState(), [
      "toggle",
    ])
  }

  public connectedCallback() {
    // Register self
    this.store.set("toggleEl", this.el)
  }

  public disconnectedCallback() {
    // Unregister self
    this.store.set("toggleEl", undefined)
  }

  public componentDidLoad() {
    this.store.subscribe()
  }

  public render() {
    return <slot />
  }
}
